import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule) },
  { path: 'dashboard', loadChildren: () => import('./pages/Dashboard/dashboard.module').then(m => m.DashboardPageModule) },
  { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule) },
  { path: 'equipos', loadChildren: () => import('./pages/equipos/equipos.module').then(m => m.EquiposPageModule) },
  { path: 'compras', loadChildren: () => import('./pages/compras/compras.module').then(m => m.ComprasPageModule) },
  { path: 'registros', loadChildren: () => import('./pages/movimientos/movimientos.module').then(m => m.MovimientosPageModule) },
  { path: 'wallet', loadChildren: () => import('./pages/wallet/wallet.module').then(m => m.WalletPageModule) },
  { path: 'accessdenied', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '/', pathMatch: 'full' }, // Ruta comodín para manejar rutas no existentes
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
